import React, { useState, useEffect } from 'react';
import Select from '../../../components/ui/Select';

const UseCaseSelector = ({ value, onChange, useCases }) => {
  const options = useCases?.map(uc => ({
    value: uc?.id,
    label: uc?.name,
    description: uc?.description
  })) || [];

  return (
    <Select
      label="Select Use Case"
      description="Choose the type of task you want to accomplish"
      options={options}
      value={value}
      onChange={onChange}
      searchable
      required
      placeholder="Select a use case..."
    />
  );
};

export default UseCaseSelector;